export default "__VITE_ASSET__P2MwnhCo__"